import { Component, Input, OnInit } from '@angular/core';
import { eActionType } from 'src/app/modules/route-planner/enums/route-planning/action-type.enum';
import { Action } from 'src/app/modules/route-planner/interfaces/route-planning/action.interface';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { WALKING } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-source-destination-route-tracking-action',
    templateUrl: './source-destination-route-tracking-action.component.html',
    styleUrl: './source-destination-route-tracking-action.component.scss',
    standalone: false
})
export class SourceDestinationRouteTrackingActionComponent implements OnInit {
  @Input() isActive: boolean;
  @Input() action: { section: Section; activeAction: Action };

  actionTypes = eActionType;
  showSwipeTooltip = true;
  walkingText: string = '';
  private static hasSwipedBefore = false;

  constructor(private readonly languageService: LanguageService) {}

  calcActionTime(): Date {
    // Ensure we have a valid Date object
    const sectionTime =
      this.action.section.departure.time instanceof Date
        ? this.action.section.departure.time
        : new Date(this.action.section.departure.time);

    // Create a new Date object to avoid modifying the original
    const resultTime = new Date(sectionTime);
    resultTime.setTime(
      resultTime.getTime() + this.action.activeAction.duration
    );

    return resultTime;
  }

  hasInstruction(): boolean {
    return !!this.action?.activeAction?.instruction;
  }

  onSwipeDetected(): void {
    SourceDestinationRouteTrackingActionComponent.hasSwipedBefore = true;
    this.showSwipeTooltip = false;
  }

  ngOnInit(): void {
    this.showSwipeTooltip =
      !SourceDestinationRouteTrackingActionComponent.hasSwipedBefore &&
      this.isActive;
    
    // Initialize walking text based on selected language
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.walkingText = WALKING[language.language];
    });
  }
}
